export const PRODUCTS_PAGE_SIZE = 10;

export const PRODUCTS_SEARCH_PARAM = {
  tab: 'tab',
  filter: 'filter',
  page: 'page'
} as const;
